import { render, staticRenderFns } from "./QianchuanCommissionRoi.vue?vue&type=template&id=7f410f0a&scoped=true"
import script from "./QianchuanCommissionRoi.vue?vue&type=script&lang=js"
export * from "./QianchuanCommissionRoi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f410f0a",
  null
  
)

export default component.exports